// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { SubEntryPointEnhancementSchema } from './SubEntryPointEnhancementSchema'
import type { SubEntryPointEnhancement } from './SubEntryPointEnhancementSchema'
import { SubEntryPointSchema } from './SubEntryPointSchema';

/////////////////////////////////////////
// SUB ENTRY POINT RELATION SCHEMA
/////////////////////////////////////////

export type SubEntryPointRelations = {
  enhancement?: SubEntryPointEnhancement | null;
};

export type SubEntryPointWithRelations = z.infer<typeof SubEntryPointSchema> & SubEntryPointRelations

export const SubEntryPointWithRelationsSchema: z.ZodType<SubEntryPointWithRelations> = SubEntryPointSchema.merge(z.object({
  enhancement: z.lazy(() => SubEntryPointEnhancementSchema).nullable(),
}))